<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="100px"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.status && scope.row.status === 'active'" type="success" size="small">Aktív</el-tag>
      <el-tag v-if="scope.row.status && scope.row.status === 'inactive'" type="danger" size="small">Inaktív</el-tag>
      <span v-if="!scope.row.status">-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'status',
  };
</script>
